export default __webpack_public_path__ + "images/b051bc6ebf3844ae15a24fbb20615ce6.png";